import { render } from "./DrawerCard.vue?vue&type=template&id=27532d22&scoped=true"
import script from "./DrawerCard.vue?vue&type=script&lang=js"
export * from "./DrawerCard.vue?vue&type=script&lang=js"

import "./DrawerCard.vue?vue&type=style&index=0&id=27532d22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27532d22"]])

export default __exports__